import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import { I18nPipe } from './i18n/i18n.pipe';
import { ListButtonDirective } from './directives/list-button.directive';
import { ContractTypeSwitchComponent } from './components/contract-type-switch/contract-type-switch.component';
import { ChipComponent } from './components/chip/chip.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { LabelledCheckboxComponent } from './components/labelled-checkbox/labelled-checkbox.component';
import { RangeSliderComponent } from './components/range-slider/range-slider.component';
import { RangeSliderKnobComponent } from './components/range-slider/range-slider-knob/range-slider-knob.component';
import { RangeSliderDropdownComponent } from './components/range-slider/range-slider-dropdown/range-slider-dropdown.component';
import { StandardDropdownComponent } from './components/standard-dropdown/standard-dropdown.component';
import { DropdownMenuComponent } from './components/dropdown-menu/dropdown-menu.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { CategoryFilterComponent } from './components/category-filter/category-filter.component';
import { LivingSpaceFilterComponent } from './components/living-space-filter/living-space-filter.component';
import { PropertySpaceFilterComponent } from './components/property-space-filter/property-space-filter.component';
import { PriceFilterComponent } from './components/price-filter/price-filter.component';
import { RoomCountFilterComponent } from './components/room-count-filter/room-count-filter.component';
import { UsageSpaceFilterComponent } from './components/usage-space-filter/usage-space-filter.component';
import { SubcategoryFilterComponent } from './components/subcategory-filter/subcategory-filter.component';
import { RemovableChipComponent } from './components/removable-chip/removable-chip.component';
import { SearchBoxComponent } from './components/search-box/search-box.component';
import { SearchInputComponent } from './components/search-input/search-input.component';
import { RadiusDropdownComponent } from './components/radius-dropdown/radius-dropdown.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FilterChipsComponent } from './components/filter-chips/filter-chips.component';
import { SuccessMessageComponent } from './components/success-message/success-message.component';
import { ListCardComponent } from './components/list-card/list-card.component';
import { LocationDisplayComponent } from './components/location-display/location-display.component';
import { SearchSubscriptionFormComponent } from './components/search-subscription-form/search-subscription-form.component';
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { ListCardDotsComponent } from './components/list-card/list-card-dots/list-card-dots.component';
import { ListCardPlaceholderComponent } from './components/list-card/list-card-placeholder/list-card-placeholder.component';
import { ListCardFlagComponent } from './components/list-card/list-card-flag/list-card-flag.component';
import { ListCardSliderComponent } from './components/list-card/list-card-slider/list-card-slider.component';

const components = [
  ListButtonDirective,
  ContractTypeSwitchComponent,
  I18nPipe,
  ChipComponent,
  CheckboxComponent,
  LabelledCheckboxComponent,
  DropdownMenuComponent,
  RangeSliderKnobComponent,
  RangeSliderDropdownComponent,
  RangeSliderComponent,
  StandardDropdownComponent,
  CategoryFilterComponent,
  LivingSpaceFilterComponent,
  PropertySpaceFilterComponent,
  PriceFilterComponent,
  RoomCountFilterComponent,
  UsageSpaceFilterComponent,
  SubcategoryFilterComponent,
  RemovableChipComponent,
  SearchInputComponent,
  SearchBoxComponent,
  RadiusDropdownComponent,
  FilterChipsComponent,
  SuccessMessageComponent,
  ListCardComponent,
  LocationDisplayComponent,
  SearchSubscriptionFormComponent,
  ListCardPlaceholderComponent,
  ListCardFlagComponent,
  ListCardDotsComponent,
  ListCardSliderComponent,
];

@NgModule({
  declarations: [components],
  exports: components,
  imports: [
    BrowserModule,
    CommonModule,
    ReactiveFormsModule,
    A11yModule,
    OverlayModule,
    HammerModule,
  ],
})
export class SharedModule {}
